module.exports = __webpack_public_path__ + "img/dispersion_illustration_card.81ebc21.jpg";